import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ComponentRef,
    HostBinding,
    Inject,
    OnInit,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'upsc-auto-close-dialog',
    templateUrl: './auto-close-dialog.component.html',
    styleUrls: ['./auto-close-dialog.component.scss'],
})
export class AutoCloseDialogComponent implements OnInit, AfterViewInit {
    @HostBinding('class') public hostClass = 'auto-close-dialog';
    @ViewChild('dynamicComponentContainer', { read: ViewContainerRef }) dynamicComponentContainer: ViewContainerRef;

    public progressValue = 100;
    public showProgressBar = true;
    public duration = 10000;
    private readonly disableAutoClose = false;
    private autoCloseTimeout: any;

    constructor(public dialogRef: MatDialogRef<AutoCloseDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private readonly cdRef: ChangeDetectorRef,
    ) {
        this.duration = this.data.duration || 10000;
        this.disableAutoClose = this.data.disableAutoClose || false;
    }

    public ngOnInit() {
        this.progressValue = 100;

        if (!this.disableAutoClose) {
            setTimeout(
                () => {
                    this.progressValue = 0;
                },
                100);

            this.autoCloseTimeout = setTimeout(
                () => {
                    this.dialogRef.close();
                },
                this.duration);
        } else {
            this.showProgressBar = false;
        }
    }

    public ngAfterViewInit() {
        if (this.data?.component) {
            const componentRef: ComponentRef<any> = this.dynamicComponentContainer.createComponent(this.data?.component);
            this.cdRef.detectChanges();

            Object.keys(this.data?.inputs).forEach((input) => {
                componentRef.instance[input] = this.data.inputs[input];
            });

            Object.keys(this.data?.outputs).forEach((output) => {
                componentRef.instance[output].subscribe(this.data.outputs[output]);
            });

            componentRef.instance?.closeParentDialog?.subscribe((value: any) => {
                this.dialogRef.close(value);
            });

            this.cdRef.detectChanges();
        }
    }

    public stopTimer() {
        clearTimeout(this.autoCloseTimeout);
        this.showProgressBar = false;
    }
}
